import { fontStyle } from "@pages/casino/assets/styles/mixins";
import styled from "styled-components";

export const CardWrapper = styled.div`
	cursor: pointer;
	border-radius: 15px;
	overflow: hidden;

	:root {
		--color1: rgb(198 198 198 / 59%);
		--color2: rgb(198 198 198 / 59%);
	}
	position: relative;

	.sparkle {
		display: none;
	}

	#game-image-wrapper {
		min-width: 282px;
		width: 282px;
		flex-direction: row;
		justify-content: flex-start;
		background: var(--casino-provider-gradient);

		@media (min-width: 1600px) {
			min-width: 350px;
			width: 350px;
		}
		.img-container {
			min-width: 136px;
			width: 136px;
			margin-bottom: 0;
			margin-right: 20px;

			@media (min-width: 1600px) {
				min-width: 170px;
				width: 170px;
			}
			&::after {
				content: "";
				display: block;
				height: 100%;
				position: absolute;
				top: 0;
				width: 100%;
				border-radius: 15px;
				box-shadow: inset 0 0 7px 3px #1d0637d4;
				mix-blend-mode: multiply;
				filter: drop-shadow(10px 10px 10px rgba(29, 10, 55, 1));
				border-radius: 15px;
			}
		}
	}

	:hover,
	:focus {
		.sparkle {
			position: absolute;
			display: block;
			z-index: 1;

			:nth-child(2) {
				top: 0;
				left: 0;
				width: 100%;
				height: 2px;
				background: linear-gradient(90deg, transparent, var(--main-color-light));
				animation: animate1 1s linear infinite;
			}

			:nth-child(3) {
				top: -100%;
				right: 0;
				width: 2px;
				height: 100%;
				background: linear-gradient(180deg, transparent, var(--main-color-light));
				animation: animate2 1s linear infinite;
				animation-delay: 0.25s;
			}

			:nth-child(4) {
				bottom: 0;
				right: 0;
				width: 100%;
				height: 2px;
				background: linear-gradient(270deg, transparent, var(--main-color-light));
				animation: animate3 1s linear infinite;
				animation-delay: 0.5s;
			}

			:nth-child(5) {
				bottom: -100%;
				left: 0;
				width: 2px;
				height: 100%;
				background: linear-gradient(360deg, transparent, var(--main-color-light));
				animation: animate4 1s linear infinite;
				animation-delay: 0.75s;
			}
		}

		@keyframes animate1 {
			0% {
				left: -100%;
			}
			50%,
			100% {
				left: 100%;
			}
		}

		@keyframes animate2 {
			0% {
				top: -100%;
			}
			50%,
			100% {
				top: 100%;
			}
		}

		@keyframes animate3 {
			0% {
				right: -100%;
			}
			50%,
			100% {
				right: 100%;
			}
		}

		@keyframes animate4 {
			0% {
				bottom: -100%;
			}
			50%,
			100% {
				bottom: 100%;
			}
		}
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 15px;
	z-index: 2;

	.img-container {
		position: relative;
		border-radius: 15px;
		margin-bottom: 10px;
		overflow: hidden;
		width: 100%;

		img {
			width: 136px;
			height: 112px;
			border-radius: 15px;
			box-shadow:
				0px 0px 20px 0px rgba(0, 0, 0, 0.25) inset,
				0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
			@media (min-width: 425px) {
				width: 170px;
				height: 140px;
			}
		}

		img[data-size="1x1"] {
			width: 136px;
			height: 112px;

			@media (min-width: 1600px) {
				width: 170px;
				height: 140px;
			}
		}
	}
`;

export const GameAffiliateName = styled.span`
	text-transform: uppercase;
	color: var(--secondary-text-color);
	${fontStyle}
	font-weight: 400;
	position: relative;
	z-index: 2;
	letter-spacing: 0.25px;
	margin-bottom: 5px;
	font-size: 10px;
	line-height: 10px;

	@media (min-width: 1600px) {
		margin-bottom: 10px;
		font-size: 14px;
		line-height: 14px;
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const GameCardContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px 10px 10px 0;
	height: 112px;
	width: 100%;
	justify-content: space-between;

	@media (min-width: 1600px) {
		height: 140px;
		padding: 10px 15px 10px 0;
	}
`;

export const GameRemoteName = styled.span`
	display: flex;
	color: #fff;
	margin-bottom: 7px;
	font-size: 18px;
	line-height: 14px;
	letter-spacing: 0.3px;
	font-size: 18px;
	font-weight: 600;
	font-variant-caps: all-petite-caps;
	line-height: 14px;
	letter-spacing: 0.3px;

	@media (min-width: 1600px) {
		font-size: 22px;
		line-height: 18px;
		letter-spacing: 0.3px;
		font-weight: 600;
		font-variant-caps: all-petite-caps;
	}
`;

export const GamePlayCount = styled.span`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 3px;

	p {
		color: var(--main-color);
		font-size: 22px;
		font-weight: 600;
		line-height: 24px;
		letter-spacing: 0.3px;
		margin: 0;
		padding: 0;

		@media (min-width: 1600px) {
			font-size: 26px;
			line-height: 26px;
		}
	}

	span {
		display: flex;
		gap: 3px;
		align-items: center;
		span {
			color: var(--secondary-text-color);
			font-size: 10px;
			font-weight: 400;
			line-height: 10px;
			letter-spacing: 0.25px;

			@media (min-width: 1600px) {
				font-size: 12px;
				line-height: 12px;
			}
		}
	}
`;

export const GamePlayArea = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;

	svg {
		z-index: 2;
		&:hover {
			@-webkit-keyframes heartbeat {
				from {
					-webkit-transform: scale(1);
					transform: scale(1);
					-webkit-transform-origin: center center;
					transform-origin: center center;
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
				10% {
					-webkit-transform: scale(0.91);
					transform: scale(0.91);
					-webkit-animation-timing-function: ease-in;
					animation-timing-function: ease-in;
				}
				17% {
					-webkit-transform: scale(0.98);
					transform: scale(0.98);
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
				33% {
					-webkit-transform: scale(0.87);
					transform: scale(0.87);
					-webkit-animation-timing-function: ease-in;
					animation-timing-function: ease-in;
				}
				45% {
					-webkit-transform: scale(1);
					transform: scale(1);
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
			}
			@keyframes heartbeat {
				from {
					-webkit-transform: scale(1);
					transform: scale(1);
					-webkit-transform-origin: center center;
					transform-origin: center center;
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
				10% {
					-webkit-transform: scale(0.91);
					transform: scale(0.91);
					-webkit-animation-timing-function: ease-in;
					animation-timing-function: ease-in;
				}
				17% {
					-webkit-transform: scale(0.98);
					transform: scale(0.98);
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
				33% {
					-webkit-transform: scale(0.87);
					transform: scale(0.87);
					-webkit-animation-timing-function: ease-in;
					animation-timing-function: ease-in;
				}
				45% {
					-webkit-transform: scale(1);
					transform: scale(1);
					-webkit-animation-timing-function: ease-out;
					animation-timing-function: ease-out;
				}
			}

			-webkit-animation: heartbeat 1.5s ease-in-out infinite both;
			animation: heartbeat 1.5s ease-in-out infinite both;
		}
	}
`;

export const GameNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;
